import appConfig from '../config/appConfig';

const getStorageKey = (key) => `${appConfig.storagePrefix}:${key}`;

export const storageService = {
  get(key, fallback = null) {
    try {
      const value = localStorage.getItem(getStorageKey(key));
      return value === null ? fallback : JSON.parse(value);
    } catch {
      return fallback;
    }
  },

  set(key, value) {
    localStorage.setItem(getStorageKey(key), JSON.stringify(value));
  },

  remove(key) {
    localStorage.removeItem(getStorageKey(key));
  },
};
